const SearchPage: React.FC = () => {
  return (
    <section
      className="mx-auto flex h-full max-w-xl flex-col justify-center gap-3 p-8 text-right"
      dir="rtl"
      aria-label="חיפוש מסמכים"
    >
      <h1 className="text-2xl font-semibold text-indigo-900">חיפוש מסמכים</h1>
      <p className="text-base text-slate-500">בפיתוח</p>
    </section>
  );
};

export default SearchPage;
